module.exports = __webpack_public_path__ + "img/Blocks.004dff9.png";